import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-homeseven-features',
  templateUrl: './homeseven-features.component.html',
  styleUrls: ['./homeseven-features.component.scss']
})
export class HomesevenFeaturesComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
